import { createContext, lazy, Suspense, useCallback, useContext, useState } from 'react';

const BookingModal = lazy(() => import('@/components/BookingModal'));
const BookingContext = createContext({ openBooking: () => {} });

export const useBooking = () => useContext(BookingContext);

export function BookingProvider({ children }) {
  const [open, setOpen] = useState(false);
  const openBooking = useCallback(() => setOpen(true), []);
  const closeBooking = useCallback(() => setOpen(false), []);

  return (
    <BookingContext.Provider value={{ openBooking }}>
      {children}
      {open && (
        <Suspense fallback={null}>
          <BookingModal isOpen={open} onClose={closeBooking} />
        </Suspense>
      )}
    </BookingContext.Provider>
  );
}
